import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';
import type { Database } from '@/integrations/supabase/types';

type AgentVoice = Database['public']['Tables']['agent_voices']['Row'];

export function useVoiceNames() {
  const [voices, setVoices] = useState<AgentVoice[]>([]);
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const fetchVoices = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('agent_voices')
        .select('*')
        .eq('is_active', true)
        .order('sort_order', { ascending: true });

      if (error) throw error;
      setVoices(data || []);
    } catch (error) {
      console.error('Error fetching voices:', error);
      toast({
        title: "Error", 
        description: "Failed to fetch voice data",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  const getVoiceName = (voiceId: string) => {
    const voice = voices.find(v => v.elevenlabs_voice_id === voiceId);
    return voice?.agent_name || 'Unknown Voice';
  };

  useEffect(() => {
    fetchVoices();
  }, []);

  return {
    voices,
    loading,
    getVoiceName,
    refreshVoices: fetchVoices,
  };
}